import { IonIcon, IonNote, IonRow, IonText } from "@ionic/react";
import { callOutline, mailOutline } from "ionicons/icons";

// --- NEW COMPONENT FOR CONTACT INFO RENDERING ---
const ContactInfo = () => (
  <div style={{ marginTop: "1rem", lineHeight: "2" }}>
    {/* Email Link */}
    <IonRow style={{ alignItems: "center", marginBottom: "10px" }}>
      <IonIcon
        icon={mailOutline}
        color="primary"
        style={{ fontSize: "1.2rem", marginRight: "8px" }}
      />
      <IonText color="dark">
        <a
          href="mailto:admin@loonlog.ca"
          style={{
            color: "var(--ion-color-dark)",
            textDecoration: "none",
            fontWeight: "bold",
          }}
        >
          admin@loonlog.ca
        </a>
      </IonText>
    </IonRow>
    <IonNote style={{ marginLeft: "30px", display: "block" }}>
      *Typically respond within 24 hours.*
    </IonNote>
    <div style={{ height: "20px" }}></div> {/* Spacer */}
    {/* Phone Link */}
    {/* <IonRow style={{ alignItems: "center", marginBottom: "10px" }}>
      <IonIcon
        icon={callOutline}
        color="primary"
        style={{ fontSize: "1.2rem", marginRight: "8px" }}
      />
      <IonText color="dark">
        <a
          href="tel:1-866-603-2259"
          style={{
            color: "var(--ion-color-dark)",
            textDecoration: "none",
            fontWeight: "bold",
          }}
        >
          1-866-603-2259
        </a>
      </IonText>
    </IonRow> */}
    {/* <div style={{ height: "20px" }}></div> Spacer */}
    {/* Office Location Text (Plain Text) */}
    <IonText color="dark" style={{ display: "block", fontWeight: "bold" }}>
      🏢 Office
    </IonText>
    <IonText
      color="medium"
      style={{
        display: "block",
        whiteSpace: "pre-wrap",
        fontSize: "14px",
        marginTop: "5px",
      }}
    >
      LOONLOG INC. Greater Vancouver Area (Burnaby) Canada
    </IonText>
  </div>
);
// --- END NEW COMPONENT ---
export default ContactInfo;
